// extracted by mini-css-extract-plugin
export var optionGrid = "_6w-7";
export var optionList = "_6w-6";
export var questionsBlock = "_6w-9";
export var spacer = "_6w-5";
export var stepCenteredContent = "_6w-3";
export var stepInner = "_6w-0";
export var stepInnerFullWidth = "_6w-1";
export var stepInnerLockScroll = "_6w-2";
export var stepTransitionFrame = "_6w-4";
export var welcomeBlock = "_6w-8";